








































































import Vue from 'vue';
import DefaultWorkflowQueue from '@/components/workflow/DefaultWorkflowQueue.vue';
import LoadingSpinner from '@/components/shared/LoadingSpinner.vue';
import MStoreGroupedTable from '@/components/shared/Table/MStoreGroupedTable.vue';
import { ScriveWorkflowJobService } from '@/services';
import SnotifyConfiguration from '@/classes/SnotifyConfiguration';
import { FormFieldValidation } from '@/mixins';
import { ScriveConstants, ScriveGroupActionModel, ScriveStandardProcessingAction } from '@/types';
import { BvTableFieldArray } from 'bootstrap-vue';
export default Vue.extend({
  name: 'ScriveWorkflowQueue',
  mixins: [DefaultWorkflowQueue, FormFieldValidation],
  props: {
    workflowQueueDataModel: {
      type: Object,
      required: true
    },
    isLoading: {
      type: Boolean,
      required: true
    }
  },
  data() {
    return {
      showModal: false,
      postIsLoading: false,
      scriveGroupActionModel: {},
      isCancelSigning: false,
      modalTitle: 'Are you sure?'
    };
  },
  computed: {
    scriveQueConfigurations(this: any) {
      return this.workflowQueueDataModel.additionalConfigurations;
    },
    scriveButtons(this: any) {
      return this.scriveQueConfigurations.scriveButtons?.filter((x: any) => x.isConfigured);
    },
    queueColumns() {
      return [...this.workflowQueueDataModel.queueColumns] as BvTableFieldArray;
    }
  },
  methods: {
    async onButtonClicked(this: any, event: any, jobs: any[]) {
      this.scriveGroupActionModel = {
        processingAction: event.processingAction,
        jobIds: jobs.map((x: any) => x.jobid)
      } as ScriveGroupActionModel;

      if (event.processingAction === ScriveStandardProcessingAction.CancelSigning) {
        this.postIsLoading = true;
        this.isCancelSigning = true;
      } else {
        const hasSignerDetails = jobs.every((job: any) => job.valid);
        if (!hasSignerDetails && event.processingAction === ScriveStandardProcessingAction.SendForSigning) {
          const jobsWithOutSigners = jobs
            .filter((job: any) => !job.valid)
            .map((job: any) => job.jobid)
            .join(', ');

          this.$bvModal.msgBoxOk(`The envelope is missing some signer details. Please update signer details for ${jobs.length > 1 ? 'Jobs:' : 'Job:'} ${jobsWithOutSigners}`, {
            title: 'Validation Error',
            okVariant: 'warning',
            noCloseOnEsc: true,
            noCloseOnBackdrop: true
          });
          return;
        }
        const confirmationMessage = this.getConfirmationMessage(event, jobs);
        const userConfirmation = await this.$bvModal.msgBoxConfirm(confirmationMessage, {
          id: 'scriveConfirmationModal',
          title: this.modalTitle,
          cancelVariant: 'danger',
          noCloseOnEsc: true,
          noCloseOnBackdrop: true
        });
        if (userConfirmation) {
          this.GroupActions(this.scriveGroupActionModel);
        }
      }
    },
    onCancelSigningReasonSubmit(this: any, event: any) {
      this.isCancelSigning = false;
      this.GroupActions(this.scriveGroupActionModel);
    },
    onCloseCancelSigningReasonModal(this: any) {
      this.isCancelSigning = false;
      this.postIsLoading = false;
      this.scriveGroupActionModel = {};
    },
    async GroupActions(this: any, data: ScriveGroupActionModel) {
      this.postIsLoading = true;
      try {
        await ScriveWorkflowJobService.GroupActionsAsync(this.workflowQueueDataModel.queueId, data);
        SnotifyConfiguration.showSuccess(ScriveConstants.SuccessMessage[data.processingAction!]);
      } catch (exception) {
        this.$log(exception);
      } finally {
        this.onCloseCancelSigningReasonModal();
        this.getWorkflowQueue();
      }
    },
    getConfirmationMessage(this: any, event: any, jobs: any[]): string {
      const groupReference = jobs[0][this.scriveQueConfigurations.groupByField];
      const selectedDocuments = jobs.length;
      const reference = this.workflowQueueDataModel.queueColumns.find((x: any) => x.key === this.scriveQueConfigurations.groupByField).label;
      switch (event.processingAction) {
        case ScriveStandardProcessingAction.SendForSigning: {
          return `You are about to create an envelope for ${selectedDocuments} document${selectedDocuments > 1 ? 's ' : ' '}for ${reference} ${groupReference}.`;
        }
        case ScriveStandardProcessingAction.Cancel: {
          const totalDocuments = this.getDocumentCountForStockNumber(groupReference);
          return `You are about to cancel ${selectedDocuments} of ${totalDocuments} document${totalDocuments > 1 ? 's ' : ' '}for ${reference} ${groupReference}.`;
        }
        default: {
          return `You are about to ${event.caption} ${groupReference}.`;
        }
      }
    },
    getDocumentCountForStockNumber(this: any, stockNumber: string): number {
      return this.workflowQueueDataModel.queueData.filter((x: any) => x[this.scriveQueConfigurations.groupByField] === stockNumber).length;
    }
  },
  components: {
    MStoreGroupedTable,
    LoadingSpinner
  }
});
